import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";

const Logo = () => (
  <img src="/obsidex.svg" alt="Obsidex" style={{width:220,height:"auto",filter:"invert(1)",display:"block",margin:"0 auto"}}/>
);

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 48 48">
    <path fill="#FFC107" d="M43.6 20H24v8h11.3C33.7 33.1 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20c11 0 19.7-8 19.7-20 0-1.3-.1-2.7-.1-4z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.5 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34.1 6.5 29.3 4 24 4c-7.7 0-14.4 4.4-17.7 10.7z"/>
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-1.8 13.6-4.7l-6.3-5.2C29.3 35.6 26.8 36 24 36c-5.2 0-9.7-2.9-11.3-7l-6.5 5C9.5 39.5 16.3 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.8l6.3 5.2C41 35.7 44 30.3 44 24c0-1.3-.1-2.7-.4-4z"/>
  </svg>
);

const EyeOpen = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);

const EyeClosed = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

export default function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { signup, googleLogin } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (password !== confirmPassword) return setError("Passwords do not match");
    if (password.length < 6) return setError("Password must be at least 6 characters");
    if (!displayName.trim()) return setError("Please enter a display name");
    setLoading(true);
    try {
      await signup(email, password, displayName.trim());
      navigate("/");
    } catch (err) {
      setError(
        err.code === "auth/email-already-in-use" ? "An account with this email already exists"
        : err.code === "auth/invalid-email" ? "Invalid email address"
        : err.code === "auth/weak-password" ? "Password is too weak"
        : "Signup failed. Please try again"
      );
    }
    setLoading(false);
  }

  async function handleGoogle() {
    setError("");
    setLoading(true);
    try {
      await googleLogin();
      navigate("/");
    } catch (err) {
      setError("Google sign in failed. Please try again.");
    }
    setLoading(false);
  }

  const baseInput = {
    width: "100%",
    background: "#0A0B0E",
    border: "1px solid #1E2028",
    borderRadius: 8,
    padding: "12px 44px 12px 14px",
    color: "#fff",
    fontSize: 14,
    outline: "none",
    fontFamily: "inherit"
  };

  const lS = {
    fontSize: 11, color: "#4B5563", textTransform: "uppercase",
    letterSpacing: ".1em", display: "block", marginBottom: 6, fontWeight: 500
  };

  const eyeBtn = {
    position: "absolute", right: 12, background: "none", border: "none",
    cursor: "pointer", padding: 0, display: "flex", alignItems: "center", justifyContent: "center"
  };

  return (
    <div style={{ minHeight: "100vh", background: "#0A0B0E", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter',-apple-system,sans-serif", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 400, background: "#111217", border: "1px solid #1E2028", borderRadius: 16, padding: 32, boxShadow: "0 20px 60px rgba(0,0,0,.5)" }}>

        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 28 }}>
          <div style={{ width: 48, height: 48, borderRadius: 12, background: "linear-gradient(135deg,#22C55E,#16A34A)", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 12 }}>
            <Logo s={26} />
          </div>
          <div style={{ fontSize: 20, fontWeight: 700, color: "#fff" }}>Create Account</div>
          <div style={{ fontSize: 12, color: "#4B5563", marginTop: 4 }}>Start your trading journal</div>
        </div>

        {error && (
          <div style={{ background: "rgba(239,68,68,.1)", border: "1px solid rgba(239,68,68,.3)", borderRadius: 8, padding: "10px 14px", color: "#EF4444", fontSize: 12, marginBottom: 16, textAlign: "center" }}>
            {error}
          </div>
        )}

        <button onClick={handleGoogle} disabled={loading} style={{ width: "100%", background: "#fff", border: "1px solid #1E2028", borderRadius: 8, padding: "11px 0", color: "#111", fontSize: 14, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center", gap: 10, marginBottom: 16 }}>
          <GoogleIcon />
          Continue with Google
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
          <div style={{ flex: 1, height: 1, background: "#1E2028" }} />
          <span style={{ fontSize: 11, color: "#4B5563" }}>OR</span>
          <div style={{ flex: 1, height: 1, background: "#1E2028" }} />
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={lS}>Display Name</label>
            <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} placeholder="Your trader tag" required
              style={{ ...baseInput, paddingRight: 14 }} />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={lS}>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required
              style={{ ...baseInput, paddingRight: 14 }} />
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={lS}>Password</label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <input type={showPass ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Min 6 characters" required style={baseInput} />
              <button type="button" onClick={() => setShowPass(p => !p)} style={{ ...eyeBtn, color: showPass ? "#22C55E" : "#6B7280" }}>
                {showPass ? <EyeClosed /> : <EyeOpen />}
              </button>
            </div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={lS}>Confirm Password</label>
            <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
              <input type={showConfirm ? "text" : "password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="••••••••" required style={baseInput} />
              <button type="button" onClick={() => setShowConfirm(p => !p)} style={{ ...eyeBtn, color: showConfirm ? "#22C55E" : "#6B7280" }}>
                {showConfirm ? <EyeClosed /> : <EyeOpen />}
              </button>
            </div>
          </div>

          <button type="submit" disabled={loading} style={{ width: "100%", background: loading ? "#1E2028" : "linear-gradient(135deg,#22C55E,#16A34A)", border: "none", borderRadius: 8, padding: "12px 0", color: "#fff", fontSize: 14, fontWeight: 600, cursor: loading ? "not-allowed" : "pointer", fontFamily: "inherit", opacity: loading ? 0.6 : 1 }}>
            {loading ? "Creating account..." : "Create Account"}
          </button>
        </form>

               <div style={{ textAlign: "center", marginTop: 18, fontSize: 13, color: "#4B5563" }}>
          Already have an account?{" "}
          <Link to="/login" style={{ color: "#22C55E", textDecoration: "none", fontWeight: 600 }}>Sign in</Link>
        </div>

        <div style={{ textAlign: "center", marginTop: 20, paddingTop: 16, borderTop: "1px solid #1E2028" }}>
          <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 6, fontWeight: 600 }}>Naineet Pujar</div>
          <div style={{ fontSize: 12, color: "#6B7280" }}>
            © {new Date().getFullYear()} Obsidex · <span style={{ cursor: "pointer", color: "#9CA3AF", textDecoration: "underline" }}>Privacy</span> · <span style={{ cursor: "pointer", color: "#9CA3AF", textDecoration: "underline" }}>Terms</span> · <span style={{ cursor: "pointer", color: "#9CA3AF", textDecoration: "underline" }}>Disclaimer</span>
          </div>
        </div>

      </div>
    </div>
  );
}